import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { useCzechTypography } from "@/lib/site";

export default function Layout({ children }) {
  useCzechTypography();
  return (
    <div className="min-h-screen flex flex-col bg-cream text-ink">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
